import * as THREE from 'three'

/**
 * Utility Function to generate additional materials / textures used in the order editor
 */
export default class EditorMaterialUtils {


  /**
   * Generate a linear gradient texture
   * Creates a 1D texture with the linear gradient
   * Sets the texture rotation to achieve the angle
   */
  static createLinearGradientTexture(colour1, colour2, angleRadians = 0) {
    const textureWidth = 256;
    const data = new Uint8Array(textureWidth * 3);
    const mixedColor = new THREE.Color();
    const tempColor = new THREE.Color();

    var stops = [
      { position: 0.0, colour: new THREE.Color(colour2) },
      { position: 0.5, colour: new THREE.Color(colour1) },
      { position: 1.0, colour: new THREE.Color(colour2) }
    ];
   
    let prevX = 0;
    for (let i = 1; i < stops.length; i++) {
      const nextX = Math.min(stops[i].position * textureWidth, textureWidth - 1);
      if (nextX > prevX) {
        const color0 = stops[i - 1].colour;
        const color1 = stops[i].colour;
        const diff = nextX - prevX;
        for (let x = prevX; x <= nextX; ++x) {
          const u = (x - prevX) / diff;
          mixedColor.copy(color0);
          mixedColor.lerp(color1, u);

          tempColor.set(mixedColor);
          data.set(tempColor.toArray().map(v => v * 255), x * 3);
        }
      }
      prevX = nextX;
    }
    
    var gradientTexture = new THREE.DataTexture(data, textureWidth, 1, THREE.RGBFormat);
    gradientTexture.rotation = angleRadians

    return gradientTexture;
  }
}
